<script setup lang="ts">
import { useTranslation } from '@/composables';
import { VBtn } from 'vuetify/components';
import { BBtn, BIcon } from '@/design-system';

const props = withDefaults(
    defineProps<{
        hideTooltip?: boolean;
        tooltipText?: string;
        btnText?: string;
        disabled?: boolean;
        btnColor?: string;
        btnClass?: string;
        iconSize?: string;
        btnDensity?: VBtn['$props']['density'];
        btnVariant?: VBtn['$props']['variant'];
        stopClickPropagation?: boolean;
    }>(),
    {
        disabled: false,
        tooltipText: 'common.remove',
        hideTooltip: false,
        btnColor: 'white',
        btnDensity: 'comfortable',
        stopClickPropagation: false,
        iconSize: 'default',
        btnVariant: 'text',
    },
);
const emit = defineEmits(['remove']);
const { t } = useTranslation();

const handleRemove = (event: MouseEvent) => {
    if (props.stopClickPropagation) {
        event.stopPropagation();
    }
    emit('remove');
};
</script>

<template>
    <BBtn
        :icon="!btnText"
        :variant="btnVariant"
        :density="btnDensity"
        :disabled="disabled"
        :color="btnColor"
        :class="btnClass"
        @click="handleRemove"
    >
        <VTooltip
            v-if="!hideTooltip"
            activator="parent"
            location="top"
        >
            {{ t(tooltipText) }}
        </VTooltip>

        <template v-if="btnText">
            <BIcon
                :size="iconSize"
                color="error"
            >
                mdi-delete-outline
            </BIcon>

            <span>{{ t(btnText) }}</span>
        </template>

        <template v-else>
            <BIcon
                :size="iconSize"
                color="error"
            >
                mdi-delete-outline
            </BIcon>
        </template>
    </BBtn>
</template>
